import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/* any functionality that external components need, and thus must be exported, goes in this file */
import { booksLink, studyLink, writingLink, flashcardsLink, mathSolverLink, internshipsLink, scholarshipsLink, moneyLink, facultyLink } from './shared/mainNavLinks';
export var defaultCentralNavLinks = {
  home: [booksLink, studyLink, writingLink, flashcardsLink, mathSolverLink, internshipsLink],
  books: [].concat(_toConsumableArray(booksLink.childLinks), [studyLink]),
  study: studyLink.childLinks,
  writing: writingLink.childLinks,
  flashcards: flashcardsLink.childLinks,
  'math-solver': mathSolverLink.childLinks,
  internships: internshipsLink.childLinks,
  'test-prep': [],
  // TODO: this is a wild use case
  scholarships: scholarshipsLink.childLinks,
  money: moneyLink.childLinks,
  faculty: facultyLink.childLinks,
  uversity: [] // No central navLinks for required for Uversity navType

}; // As borderRadius Module is removed from Chegg-ui/theme, so adding it here to support Chegg Header

export var borderRadius = {
  small: '4px',
  medium: '6px',
  large: '8px'
};
/**
 * This is to map Data Powered Header's GQL data source
 */

export var HEADER_DATA_SOURCE = 'headerDataSource';